import { Entity } from '@api/api/entity-schema';
import { Drawer } from '@design/components/drawer/Drawer';
import { DrawerContentWrapper } from '@terminal/components/drawer-content-wrapper/DrawerContentWrapper';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { CompanyToGeoWidget } from '@terminal/widgets/company-to-geo-widget/CompanyToGeoWidget';
import { useTranslation } from 'react-i18next';

import styles from './GeographicExposureDrawer.module.scss';
import { useGeographicDrawer } from './useGeographicDrawer';

export const DRAWER_GEOGRAPHIC_EXPOSURE = 'geographicExposure';

export interface GeographicExposureDrawerProps {
  entity: Entity;
}

export const GeographicExposureDrawer = ({
  entity,
}: GeographicExposureDrawerProps) => {
  const { closeDrawer, isDrawerOpen, type, countryCode, regionName } =
    useGeographicDrawer();
  const { t } = useTranslation(['countries']);
  const isConnectionsDrawersOverhaul = useFlags(state =>
    state.getFeatureFlagState('PLATFORM-5359-connections-drawers-overhaul')
  );

  const getHeaderLabel = () => {
    if (type === 'country' && countryCode) {
      return t(`countries:${countryCode.toUpperCase()}`);
    }

    if (type === 'region' && regionName) {
      return regionName;
    }

    return '';
  };

  const headerLabel = getHeaderLabel();
  const hasTarget = !!type && !!headerLabel;

  return (
    <Drawer
      className={
        isConnectionsDrawersOverhaul ? styles.compactHeader : undefined
      }
      data-testid="geographic-exposure-drawer"
      isOpen={isDrawerOpen && hasTarget}
      handleCloseClick={closeDrawer}
      headerButton={
        isConnectionsDrawersOverhaul ? undefined : (
          <div className={styles.headerTitle}>{headerLabel}</div>
        )
      }
    >
      <DrawerContentWrapper className={styles.drawerContent}>
        <CompanyToGeoWidget entity={entity} />
      </DrawerContentWrapper>
    </Drawer>
  );
};
